import { Box, Typography, Grid } from "@mui/material";
import React, { useState, useEffect } from 'react';
import Select from "react-select";
import { hoursOptions, minutesOptions, timecaseOptions } from "../../constant";
import palette from "../../theme/palette";

const customStyles = {
    dropdownIndicator: (base) => ({
        ...base,
        color: palette.text.light,
        flex: "1",
        width: "100%",
    }),
    indicatorSeparator: () => null,
    container: (base) => ({ ...base, flex: "1", width: "100%" }),
    menuPortal: base => ({ ...base, zIndex: 9999 })
};

export default function CustomTimePicker({ hide, size, i, value, setValue, disabled }) {
    return (
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={size ? size : 4}>
                    <Select
                        styles={customStyles}
                        options={hoursOptions}
                        required
                        classNamePrefix="standardSelect"
                        placeholder={
                            <Typography variant="formLabel">
                                Hours
                            </Typography>
                        }
                        isSearchable={false}
                        isClearable={true}
                        isDisabled={disabled ? disabled : false}
                        name="hours"
                        value={value?.hours || ""}
                        onChange={(e) => setValue({
                            ...value,
                            hours: e
                        }, i)}
                    />
                </Grid>
                <Grid item xs={size ? size : 4}>
                    <Select
                        styles={customStyles}
                        options={minutesOptions}
                        required
                        classNamePrefix="standardSelect"
                        placeholder={
                            <Typography variant="formLabel">
                                Minutes
                            </Typography>
                        }
                        isSearchable={false}
                        isDisabled={disabled ? disabled : false}
                        isClearable={true}
                        name="minutes"
                        value={value?.minutes || ""}
                        onChange={(e) => setValue({
                            ...value,
                            minutes: e
                        }, i)}
                    />
                </Grid>
                {!hide && <Grid item xs={size ? size : 4}>
                    <Select
                        styles={customStyles}
                        options={timecaseOptions}
                        required
                        classNamePrefix="standardSelect"
                        placeholder={
                            <Typography variant="formLabel">
                                Select time type
                            </Typography>
                        }
                        isSearchable={false}
                        isDisabled={disabled ? disabled : false}
                        isClearable={true}
                        name="typeTime"
                        value={value?.typeTime || ""}
                        onChange={(e) => setValue({
                            ...value,
                            typeTime: e
                        }, i)}
                    />
                </Grid>}
            </Grid>
        </Box>
    )
}